// extracted by mini-css-extract-plugin
module.exports = {"settings":"BulkUserSettings-module__settings___2wkbL"};